import React from 'react';
import type {BoxProps} from '@tempo/core';
import {Box, Flex, HStack} from '@tempo/core';

type FooterRowProps = {
	leftElements?: React.ReactNode;
	rightElements?: React.ReactNode;
} & BoxProps;

const FooterRow = ({leftElements, rightElements, ...props}: FooterRowProps) => {
	return (
		<Flex
			justifyContent="space-between"
			px={{base: 'spacing.m', sm: 'spacing.l', md: 'spacing.xl'}}
			py={{base: 'spacing.s', md: 'spacing.m'}}
			alignItems="center"
			borderTopStyle={'solid'}
			borderTopWidth={'1px'}
			borderColor={'divider.neutral.primary.default'}
			{...props}
		>
			<Box flex={1}>
				<HStack spacing="spacing.s">{leftElements}</HStack>
			</Box>
			<Box>
				<HStack spacing="spacing.s">{rightElements}</HStack>
			</Box>
		</Flex>
	);
};

export default FooterRow;
